'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerInput = exports.DatePicker = undefined;

var _DatePicker2 = require('./DatePicker');

var _DatePicker3 = _interopRequireDefault(_DatePicker2);

var _DatePickerInput2 = require('./DatePickerInput');

var _DatePickerInput3 = _interopRequireDefault(_DatePickerInput2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DatePicker = _DatePicker3.default;
exports.DatePickerInput = _DatePickerInput3.default;
exports.default = { DatePicker: _DatePicker3.default, DatePickerInput: _DatePickerInput3.default };


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-datepicker/lib/index.js
 ** module id = 1046
 ** module chunks = 0
 **/